import { useCallback, useMemo } from 'react';
import { webSearch } from '../services/ai/webSearch';
import { fetchUrl } from '../services/ai/fetchUrl';

/**
 * AI executors for web discovery — `web_search` and `fetch_url` (22.08.2026).
 *
 * Both are thin: the logic lives in services/ai/webSearch.js and fetchUrl.js
 * so it is testable without React. A separate hook from useAiWorkspaceActions
 * on purpose: these touch no workspace state at all — one talks to our API,
 * the other to the public internet — and the handler-map dispatch in
 * AIChatPanel takes any number of maps merged in App.js.
 */
export function useAiDiscoveryActions() {
  const aiWebSearch = useCallback(async (input = {}) => webSearch({ query: input.query }), []);
  const aiFetchUrl = useCallback(async (input = {}) => fetchUrl({ url: input.url }), []);

  return useMemo(() => ({
    web_search: aiWebSearch,
    fetch_url: aiFetchUrl,
  }), [aiWebSearch, aiFetchUrl]);
}
